import { UseFormMethods } from 'react-hook-form';
import { RFQ_REGISTER_INFO } from '@modules/request/types';
import {
  CapaQuotationDetailedServiceType,
  CapaQuotationProductPurpose,
  CapaQuotationServiceType
} from '@generated/graphql';

export interface IDialogData {
  type?: 'delete' | 'change';
  file_key?: string;
}

export interface RequestProps {
  isUploading?: boolean;
  handleSubmit: (_: any) => void;
  dialogData: IDialogData;
  onClose: () => void;
  onChange: () => void;
  useHookForm: UseFormMethods<
    RFQ_REGISTER_INFO & { dueNegotiable: ['true' | 'false'] }
  >;
}

export const ServiceTypeInfo: Record<
  CapaQuotationServiceType,
  { text: string; acceptText: string; accept: string } | undefined
> = {
  [CapaQuotationServiceType.Cnc]: {
    text: 'CNC 가공',
    acceptText: '파일 확장자 : .dwg, .dxf, .stp, .step',
    accept: '.dwg, .dxf, .stp, .step'
  },
  [CapaQuotationServiceType.Printing]: {
    text: '3D 프린팅',
    acceptText: `.STL, .OBJ, .STP, .STEP, .IGS, .IGES 이외의 확장자는 ‘지원하는 파일 확장자'에서 확인해주세요`,
    accept: `.OBJ, .SKP, .STL, .SAT, .SAB, .IPT, .MODEL, .SESSION, .DLV, .EXP, .CATPart, .CGR, .DAE, .NEU, .PRT, .XPR, .FBX, .GLTF, .GLB, .IFC, .IGS, .IGES, .JT, .X_B, .X_T, .RVT, .3DM, .PAR, .PSM, .SLDPRT, .STP, .STEP`
  },
  [CapaQuotationServiceType.Inj]: {
    text: '금형사출',
    acceptText: '파일 확장자 : .stp, .step',
    accept: '.stp, .step'
  },
  [CapaQuotationServiceType.SheetMetal]: {
    text: '판금 가공',
    acceptText: '파일 확장자 : .dwg, .dxf',
    accept: '.dwg, .dxf'
  },
  [CapaQuotationServiceType.MechanicalDesign]: {
    text: '기구 설계',
    acceptText: '',
    accept: ''
  },
  [CapaQuotationServiceType.Casting]: {
    text: '주조',
    acceptText: '파일 확장자 : .dwg, .dxf',
    accept: '.dwg, .dxf'
  },
  [CapaQuotationServiceType.ProductDesign]: {
    text: '제품 디자인',
    acceptText: '',
    accept: ''
  },
  [CapaQuotationServiceType.Bending]: undefined,
  [CapaQuotationServiceType.Weilding]: undefined,
  [CapaQuotationServiceType.Prototyping]: undefined,
  [CapaQuotationServiceType.Pcb]: undefined,
  [CapaQuotationServiceType.Design]: undefined
};

export const printingProcessMethod = [
  'SLA',
  'FDM',
  'Polyjet',
  'MJF',
  'SLS',
  'SLM/DMLS',
  '파트너로부터 가공 방식, 재료 추천을 받겠습니다.'
];

export const printingMaterialMethod: any = {
  [CapaQuotationDetailedServiceType.Sla]: [
    '레진 (흰색)',
    '레진 (투명)',
    '레진 (반투명)',
    '파트너로부터 재료 추천을 받겠습니다.'
  ],
  [CapaQuotationDetailedServiceType.Fdm]: [
    'PLA',
    'ABS (산업용)',
    '파트너로부터 재료 추천을 받겠습니다.'
  ],
  [CapaQuotationDetailedServiceType.Polyjet]: [
    'Vero (멀티 컬러)',
    '고무 유사',
    '파트너로부터 재료 추천을 받겠습니다.'
  ],
  [CapaQuotationDetailedServiceType.Mjf]: [
    'PA12',
    '파트너로부터 재료 추천을 받겠습니다.'
  ],
  [CapaQuotationDetailedServiceType.Sls]: [
    'PA12',
    '파트너로부터 재료 추천을 받겠습니다.'
  ],
  [CapaQuotationDetailedServiceType.SlmDmls]: [
    'Aluminum',
    'Stainless Steel',
    '파트너로부터 재료 추천을 받겠습니다.'
  ],
  [CapaQuotationDetailedServiceType.Recommend]: []
};

export const castingMaterialMethod: any = {
  '사형 주조(Sand Casting)': [
    '주철(Iron)',
    '주강(Steel)',
    '알루미늄 합금(Aluminum)',
    '아연 합금(Zinc)',
    '마그네슘 합금(Magnesium)',
    '동합금(Copper)',
    '기타 재료(직접 입력)',
    '추천이 필요합니다'
  ],
  '쉘 주조(Shell Moulding)': [
    '주철(Iron)',
    '주강(Steel)',
    '알루미늄 합금(Aluminum)',
    '아연 합금(Zinc)',
    '마그네슘합금 (Magnesium)',
    '동합금(Copper)',
    '기타 재료(직접 입력)',
    '추천이 필요합니다'
  ],
  '인베스트먼트 주조(Investment Casting)': [
    '주철(Iron)',
    '주강(Steel)',
    '알루미늄 합금(Aluminum)',
    '아연 합금(Zinc)',
    '마그네슘 합금(Magnesium)',
    '동합금(Copper)',
    '기타 재료(직접 입력)',
    '추천이 필요합니다'
  ],
  '다이캐스팅(Die Casting)': [
    '주철(Iron)',
    '주강(Steel)',
    '알루미늄 합금(Aluminum)',
    '아연 합금(Zinc)',
    '마그네슘 합금(Magnesium)',
    '동합금(Copper)',
    '기타 재료(직접 입력)',
    '추천이 필요합니다'
  ],
  '원심 주조(Centrifugal Casting)': [
    '주철(Iron)',
    '주강(Steel)',
    '알루미늄 합금(Aluminum)',
    '아연 합금(Zinc)',
    '마그네슘 합금(Magnesium)',
    '동합금(Copper)',
    '기타 재료(직접 입력)',
    '추천이 필요합니다'
  ],

  '파트너 추천이 필요합니다': []
};

export const sheetMetalProcessMethod = [
  '프레스',
  '레이저 커팅',
  '워터젯 커팅',
  '파트너로부터 재료 추천을 받겠습니다.'
];
export const sheetingMaterial = [
  'Aluminum',
  'Stainless Steel',
  'Carbon Steel',
  'Galvanized Steel',
  'Copper',
  '파트너로부터 재료 추천을 받겠습니다.',
  '기타 재료 (직접 입력)'
];

export const projectPurposeOptions: Record<
  CapaQuotationProductPurpose | 'part1' | 'part2' | 'part3',
  string
> = {
  'part1': '-------------- 산업 카테고리 --------------',
  [CapaQuotationProductPurpose.AutomobileTransportation]: '자동차 / 운송',
  [CapaQuotationProductPurpose.ManufacturinEquipmentIndustrialMachineAndParts]:
    '생산 설비 / 장비 및 부속품',
  [CapaQuotationProductPurpose.RoboticsDroneIotSmartDevice]:
    '로봇 / 드론 / IOT / 스마트기기',
  [CapaQuotationProductPurpose.MedicalHealthcare]: '의료 / 건강',
  [CapaQuotationProductPurpose.SemiconductorElectronicBoards]: '반도체 / 기관',
  [CapaQuotationProductPurpose.OpticsMaterials]: '광학 / 신소재',
  [CapaQuotationProductPurpose.HouseholdAppliance]: '가전',
  [CapaQuotationProductPurpose.ExperimentInspectionDiagnosisMeasuring]:
    '검사 / 시험 / 진단 / 측정 장비',
  [CapaQuotationProductPurpose.EnergyBatteries]: '에너지 / 배터리',
  [CapaQuotationProductPurpose.BroadcastCommunicationMultimedia]:
    '방송 / 통신 / 멀티미디어',
  [CapaQuotationProductPurpose.ResearchAndDevelopment]: '연구개발',
  [CapaQuotationProductPurpose.Aerospace]: '항공 / 우주',
  [CapaQuotationProductPurpose.MilitarySafety]: '국방 / 안전',
  [CapaQuotationProductPurpose.OceanIndustryShipbuilding]: '해양 / 선박',
  [CapaQuotationProductPurpose.AgricultureFarming]: '농업',
  [CapaQuotationProductPurpose.GadgetsPartsComponents]: '주변기기 / 부속 부품',
  'part2': '-------------- 일반 카테고리 --------------',
  [CapaQuotationProductPurpose.KitchenFood]: '주방 / 식품',
  [CapaQuotationProductPurpose.EducationToys]: '교육 / 완구',
  [CapaQuotationProductPurpose.SportsOutdoors]: '스포츠 / 아웃도어',
  [CapaQuotationProductPurpose.FashionBeauty]: '패션 / 뷰티',
  [CapaQuotationProductPurpose.InteriorLiving]: '인테리어 / 리빙',
  [CapaQuotationProductPurpose.Furniture]: '가구',
  [CapaQuotationProductPurpose.Pets]: '반려동물',
  [CapaQuotationProductPurpose.PropsOfficeSupplies]: '생활소품 / 사무용품',
  [CapaQuotationProductPurpose.ArtsExhibition]: '예술 / 전시',
  [CapaQuotationProductPurpose.ArchitectureConstruction]: '건축 / 공사',
  [CapaQuotationProductPurpose.PersonalHobby]: '개인 / 취미',
  'part3': '-------------- 기타 / 미분류 --------------',
  [CapaQuotationProductPurpose.Etc]: '기타(직접 입력)'
};

export interface DialogTypes {
  connectDrive: boolean;
  preview: boolean;
  MdGuide: boolean;
  welcome: boolean;
  registerConnect: boolean;
  profileUpdate: boolean;
  howTo: boolean;
}

export const initialDialogState: DialogTypes = {
  connectDrive: false,
  preview: false,
  MdGuide: false,
  welcome: false,
  registerConnect: false,
  profileUpdate: false,
  howTo: false
};
